import React from "react";
import "./Map.css";
import { COMPANY_ADDRESS_MAP_QUERY } from "../../constants/contact";

function Map() {
    return (
        <div className='main_div_map_hoempage'>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-12 p-0 mt-5 '>
            <iframe
              src={`https://maps.google.com/maps?q=${COMPANY_ADDRESS_MAP_QUERY}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
              width="100%"
              height="480"
              className='map_setting_style'
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          
        </div>
        </div>
      );
    }

export default Map
